import angular from 'angular';

import ContributorsCtrl from './contributors.controller';
import ContributorsModalConf from './contributors.config';

import TitlecaseFilter from '../../filters/titlecase';

export default angular.module('modals.contributors', [ContributorsCtrl,TitlecaseFilter])
	.constant('ContributorsModalConf', ContributorsModalConf)
	.name;



// WEBPACK FOOTER //
// ./project/modals/contributors/index.js